import { Container, Row, Col, Card, Accordion, Button } from 'react-bootstrap';

const Help = () => {
  const faqCategories = [
    {
      title: 'Getting Started',
      icon: 'bi-rocket-takeoff',
      faqs: [
        {
          question: 'How do I create an account?',
          answer: 'Click the "Sign Up" button on the homepage, fill in your details including email, username, and password, then verify your email address to activate your account.'
        },
        {
          question: 'How do I complete my profile?',
          answer: 'After logging in, go to "My Profile" and click "Edit Profile". Add your photos, write a bio, and fill in your preferences to help us find better matches for you.'
        },
        {
          question: 'Is Paperdate free to use?',
          answer: 'Paperdate offers both free and premium features. Basic browsing and messaging are free, while advanced features like unlimited messaging and profile boosts require credits.'
        }
      ]
    },
    {
      title: 'Profile & Photos',
      icon: 'bi-person-circle',
      faqs: [
        {
          question: 'How do I upload photos?',
          answer: 'Go to "My Photos" from the menu, click "Upload Photos", and select images from your device. Photos are reviewed before being published to ensure community guidelines are met.'
        },
        {
          question: 'Why was my photo rejected?',
          answer: 'Photos may be rejected if they contain inappropriate content, are low quality, or don\'t clearly show your face. Ensure your photos follow our community guidelines.'
        },
        {
          question: 'How do I set my profile picture?',
          answer: 'In your photo gallery, click the star icon on any approved photo to set it as your main profile picture.'
        }
      ]
    },
    {
      title: 'Matching & Messaging',
      icon: 'bi-chat-heart',
      faqs: [
        {
          question: 'How does matching work?',
          answer: 'Our smart matching algorithm considers your preferences, location, interests, and activity to suggest compatible profiles. Browse matches in the Search section.'
        },
        {
          question: 'How do I send a message?',
          answer: 'Visit a user\'s profile and click the message button, or go to Messages and start a new conversation. Some messaging features may require credits.'
        },
        {
          question: 'Can I see who viewed my profile?',
          answer: 'Yes! Check the "Profile Views" section on your dashboard to see who has recently viewed your profile.'
        }
      ]
    },
    {
      title: 'Safety & Privacy',
      icon: 'bi-shield-check',
      faqs: [
        {
          question: 'How do I block someone?',
          answer: 'Visit the user\'s profile and click the block button. Blocked users cannot view your profile or send you messages.'
        },
        {
          question: 'How do I report inappropriate behavior?',
          answer: 'Use the report button on any profile or message to flag inappropriate content. Our team reviews all reports within 24 hours.'
        },
        {
          question: 'Is my personal information safe?',
          answer: 'We use industry-standard encryption and never share your personal information with third parties. Review our Privacy Policy for details.'
        }
      ]
    }
  ];

  return (
    <Container className="py-5">
      <Row className="justify-content-center mb-5">
        <Col lg={8} className="text-center">
          <h1 className="display-4 fw-bold mb-4">Help Center</h1>
          <p className="lead text-muted">
            Find answers to common questions and learn how to get the most out of Paperdate.
          </p>
        </Col>
      </Row>

      <Row className="mb-5">
        <Col lg={4} className="mb-4 mb-lg-0">
          <Card className="border-0 shadow-sm h-100 text-center">
            <Card.Body className="p-4">
              <i className="bi bi-envelope display-4 text-primary mb-3"></i>
              <h5 className="fw-bold">Email Support</h5>
              <p className="text-muted mb-3">Get help from our support team</p>
              <Button variant="outline-primary" href="mailto:support@paperdate.io">
                support@paperdate.io
              </Button>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={4} className="mb-4 mb-lg-0">
          <Card className="border-0 shadow-sm h-100 text-center">
            <Card.Body className="p-4">
              <i className="bi bi-chat-dots display-4 text-primary mb-3"></i>
              <h5 className="fw-bold">Live Chat</h5>
              <p className="text-muted mb-3">Chat with us in real-time</p>
              <Button variant="outline-primary">Start Chat</Button>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={4}>
          <Card className="border-0 shadow-sm h-100 text-center">
            <Card.Body className="p-4">
              <i className="bi bi-book display-4 text-primary mb-3"></i>
              <h5 className="fw-bold">User Guide</h5>
              <p className="text-muted mb-3">Detailed documentation</p>
              <Button variant="outline-primary">View Guide</Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col>
          <h2 className="fw-bold">Frequently Asked Questions</h2>
        </Col>
      </Row>

      <Row>
        {faqCategories.map((category, catIndex) => (
          <Col lg={6} key={catIndex} className="mb-4">
            <Card className="border-0 shadow-sm h-100">
              <Card.Header className="bg-white border-0 p-4">
                <h5 className="fw-bold mb-0">
                  <i className={`bi ${category.icon} text-primary me-2`}></i>
                  {category.title}
                </h5>
              </Card.Header>
              <Card.Body className="p-0">
                <Accordion flush>
                  {category.faqs.map((faq, faqIndex) => (
                    <Accordion.Item key={faqIndex} eventKey={`${catIndex}-${faqIndex}`}>
                      <Accordion.Header>{faq.question}</Accordion.Header>
                      <Accordion.Body className="text-muted">
                        {faq.answer}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Help;

